import NerisGroupsForm from './NerisGroupsForm';
import React, { useEffect } from 'react';
import {
  getTypeFormSettings,
  saveTypeFormSettings,
  setTypeSettings,
} from '../../store/nerisSettingsReducer';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Card, CircularProgress, Grid, Typography } from '@mui/material';
import NerisTypesForm from './NerisTypesForm';

const NerisGroupAndTypes = () => {
  const { typeSaveFetching, loadingTypeSettings, type } = useSelector(
    (state) => state.nerisSettingsReducer
  );

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getTypeFormSettings());
    return () => {
      dispatch(setTypeSettings());
    };
  }, []);

  const handleGroupsSubmit = (groups) => {
    dispatch(
      saveTypeFormSettings({
        ...type,
        groups,
      })
    );
  };

  const handleTypesSubmit = (types) => {
    dispatch(
      saveTypeFormSettings({
        ...type,
        types,
      })
    );
  };

  if (loadingTypeSettings) {
    return (
      <Box
        sx={{ minHeight: '100px' }}
        className="w-100 h-100 d-flex justify-content-center align-items-center"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Card
            className="p-3 mt-4"
            sx={{
              boxShadow: '0px 4px 4px 0px #0000000F',
            }}
          >
            <Typography
              variant="h5"
              component="h1"
              sx={{ mb: 3, fontWeight: 600 }}
            >
              Neris Types
            </Typography>
            <NerisGroupsForm
              initialData={type.groups}
              onSubmit={handleGroupsSubmit}
              loading={typeSaveFetching}
            />
          </Card>

          <Card
            className="p-3 mt-4"
            sx={{
              boxShadow: '0px 4px 4px 0px #0000000F',
            }}
          >
            <Typography
              variant="h5"
              component="h1"
              sx={{ mb: 3, fontWeight: 600 }}
            >
              Neris Sub Types
            </Typography>
            <NerisTypesForm
              groups={type.groups}
              initialData={type.types}
              onSubmit={handleTypesSubmit}
              loading={typeSaveFetching}
            />
          </Card>
        </Grid>
      </Grid>
  );
};

export default NerisGroupAndTypes;
